module.exports = __webpack_public_path__ + "img/ErstmalPause.09bd46d1.svg";